import $ from 'jquery';
window.$ = $;
import Dispatcher from '../dispatcher';
import resolvePromise from '../helper/resolved_promise';
import { VehicleConfiguratorActions } from '../constants/configurator/vehicle_configurator_actions';
import VehicleSelectorAnalytics from '../../_modules/google_analytics/vehicle_selector';

function submitVehicleSelectorForm() {
    VehicleSelectorAnalytics.submitAction();
}

function showAction() {
    VehicleSelectorAnalytics.openAction();
    Dispatcher.handleVehicleConfiguratorAction({
        type: VehicleConfiguratorActions.SHOW_ACTION
    });
}

function showActionV2(fromTyreSize) {
    VehicleSelectorAnalytics.openAction();
    Dispatcher.handleVehicleConfiguratorAction({
        type: VehicleConfiguratorActions.SHOW_ACTION_V2,
        payload: fromTyreSize,
    });
}

function showVehicleNotProvidedLayerAction() {
    VehicleSelectorAnalytics.showVehicleNotProvidedLayer();
    Dispatcher.handleVehicleConfiguratorAction({
        type: VehicleConfiguratorActions.SHOW_VEHICLE_NOT_PROVIDED_LAYER,
    });

    return resolvePromise();
}

function hideVehicleNotProvidedLayerAction() {
    VehicleSelectorAnalytics.hideVehicleNotProvidedLayer();
    Dispatcher.handleVehicleConfiguratorAction({
        type: VehicleConfiguratorActions.HIDE_VEHICLE_NOT_PROVIDED_LAYER,
    });

    return resolvePromise();
}

function setVehicleNotProvidedCommentAction(comment) {
    VehicleSelectorAnalytics.setVehicleNotProvidedCommentAction(comment);
    Dispatcher.handleVehicleConfiguratorAction({
        type: VehicleConfiguratorActions.SET_VEHICLE_NOT_PROVIDED_COMMENT,
        payload: comment
    });

    return resolvePromise();
}

function showVehicleConfiguratorFromConfiguratorLayerAction() {
    VehicleSelectorAnalytics.openFromConfiguratorAction();
    Dispatcher.handleVehicleConfiguratorAction({
        type: VehicleConfiguratorActions.SHOW_ACTION
    });
}

function hideAction() {
    Dispatcher.handleVehicleConfiguratorAction({
        type: VehicleConfiguratorActions.HIDE_ACTION
    });

    return resolvePromise();
}

function closeVehicleConfigurator() {
    VehicleSelectorAnalytics.closeAction();
    Dispatcher.handleVehicleConfiguratorAction({
        type: VehicleConfiguratorActions.HIDE_ACTION
    });

    return resolvePromise();
}

function showMainLayerAction() {
    Dispatcher.handleVehicleConfiguratorAction({
        type: VehicleConfiguratorActions.SHOW_MAIN_LAYER,
    });

    return resolvePromise();
}

function setPostcodeAction(postcode) {
    Dispatcher.handleVehicleConfiguratorAction({
        type: VehicleConfiguratorActions.SET_POSTCODE,
        payload: postcode
    });

    return resolvePromise();
}

function onVehiclePostcodeInputLeave(postcode) {
    VehicleSelectorAnalytics.setPostcodeAction(postcode);
    return resolvePromise();
}

function showPostcodeInvalidAction() {
    VehicleSelectorAnalytics.postcodeInvalid();
    Dispatcher.handleVehicleConfiguratorAction({
        type: VehicleConfiguratorActions.SHOW_POSTCODE_INVALID,
    });

    return resolvePromise();
}

function hidePostcodeInvalidAction() {
    Dispatcher.handleVehicleConfiguratorAction({
        type: VehicleConfiguratorActions.HIDE_POSTCODE_INVALID,
    });

    return resolvePromise();
}

function setMakeAction(make) {
    VehicleSelectorAnalytics.setMakeAction(make);
    Dispatcher.handleVehicleConfiguratorAction({
        type: VehicleConfiguratorActions.SET_MAKE,
        payload: make
    });

    return resolvePromise();
}

function setModelAction(model) {
    VehicleSelectorAnalytics.setModelAction(model);
    Dispatcher.handleVehicleConfiguratorAction({
        type: VehicleConfiguratorActions.SET_MODEL,
        payload: model
    });

    return resolvePromise();
}

function setYearAction(year) {
    VehicleSelectorAnalytics.setYearAction(year);
    Dispatcher.handleVehicleConfiguratorAction({
        type: VehicleConfiguratorActions.SET_YEAR,
        payload: year
    });

    return resolvePromise();
}

function setSeriesChassisAction(seriesChassis) {
    VehicleSelectorAnalytics.setSeriesChassisAction(seriesChassis);
    Dispatcher.handleVehicleConfiguratorAction({
        type: VehicleConfiguratorActions.SET_SERIES_CHASSIS,
        payload: seriesChassis
    });

    return resolvePromise();
}

function setEngineAction(engine) {
    VehicleSelectorAnalytics.setEngineAction(engine);
    Dispatcher.handleVehicleConfiguratorAction({
        type: VehicleConfiguratorActions.SET_ENGINE,
        payload: engine
    });

    return resolvePromise();
}

function setDetailsAction(details) {
    VehicleSelectorAnalytics.setDetailsAction(details);
    Dispatcher.handleVehicleConfiguratorAction({
        type: VehicleConfiguratorActions.SET_DETAILS,
        payload: details
    });

    return resolvePromise();
}

function setTyresAction(tyres) {
    VehicleSelectorAnalytics.setTyresAction(tyres);
    Dispatcher.handleVehicleConfiguratorAction({
        type: VehicleConfiguratorActions.SET_TYRES,
        payload: tyres
    });

    return resolvePromise();
}

function setValuesAction(values) {
    Dispatcher.handleVehicleConfiguratorAction({
        type: VehicleConfiguratorActions.SET_VALUES,
        payload: values
    });

    return resolvePromise();
}

function resetValuesAction() {
    Dispatcher.handleVehicleConfiguratorAction({
        type: VehicleConfiguratorActions.RESET_VALUES,
    });

    return resolvePromise();
}

function setLoadingCheckAction(filterName) {
    Dispatcher.handleVehicleConfiguratorAction({
        type: VehicleConfiguratorActions.SET_LOADING_CHECK,
        payload: filterName
    });

    return resolvePromise();
}

function setLoadingCheckDoneAction() {
    Dispatcher.handleVehicleConfiguratorAction({
        type: VehicleConfiguratorActions.SET_LOADING_CHECK_DONE
    });

    return resolvePromise();
}

function setOutOfStockAction(payload) {
    Dispatcher.handleVehicleConfiguratorAction({
        type: VehicleConfiguratorActions.SET_OUT_OF_STOCK,
        payload
    });

    return resolvePromise();
}

function setInStockAction() {
    Dispatcher.handleVehicleConfiguratorAction({
        type: VehicleConfiguratorActions.SET_IN_STOCK
    });

    return resolvePromise();
}

function setTyreOptionsAction(tyreOptions) {
    Dispatcher.handleVehicleConfiguratorAction({
        type: VehicleConfiguratorActions.SET_TYRE_OPTIONS,
        payload: tyreOptions
    });

    return resolvePromise();
}

function setPostSuggestionVehicleConfigurator(payload) {
    Dispatcher.handleVehicleConfiguratorAction({
        type: VehicleConfiguratorActions.SET_POSTCODE_SUGGESTION,
        payload
    });
}

function showInfoLayerAction() {
    VehicleSelectorAnalytics.showInfoAction();
    Dispatcher.handleVehicleConfiguratorAction({
        type: VehicleConfiguratorActions.SHOW_INFO_LAYER,
    });

    return resolvePromise();
}

function hideInfoLayerAction() {
    Dispatcher.handleVehicleConfiguratorAction({
        type: VehicleConfiguratorActions.HIDE_INFO_LAYER,
    });

    return resolvePromise();
}

export {
    showAction,
    showActionV2,
    showVehicleNotProvidedLayerAction,
    hideVehicleNotProvidedLayerAction,
    setVehicleNotProvidedCommentAction,
    hideAction,
    showMainLayerAction,
    setMakeAction,
    setModelAction,
    setYearAction,
    setSeriesChassisAction,
    setEngineAction,
    setDetailsAction,
    setTyresAction,
    setValuesAction,
    resetValuesAction,
    setLoadingCheckAction,
    setLoadingCheckDoneAction,
    setOutOfStockAction,
    setInStockAction,
    setPostcodeAction,
    showPostcodeInvalidAction,
    hidePostcodeInvalidAction,
    setPostSuggestionVehicleConfigurator,
    setTyreOptionsAction,
    closeVehicleConfigurator,
    showVehicleConfiguratorFromConfiguratorLayerAction,
    onVehiclePostcodeInputLeave,
    submitVehicleSelectorForm,
    showInfoLayerAction,
    hideInfoLayerAction,
};
